<img class="img-placeholder fade-in"
     #img
     alt=""
     aria-hidden="true"
     [lazyLoad]="imageUrl"
     [errorImage]="errorImage"
     (onStateChange)="myCallbackFunction($event)">
